/**
 * IXD/DSD 대사 화면(`/ixd-dsd-compare`)의 URL 계약.
 *
 * 대사 화면과 홈 패널이 함께 대사를 시작하므로 features 밖 순수 함수로 둔다
 * — 파라미터명이 바뀌면 고칠 곳은 여기 한 곳.
 *
 * 상대 경로를 돌려준다: `window.open` / `location.replace` / 라우터 `navigate` 가 모두 받는다.
 */
export const PARAM_COMPARISON_ID = "comparisonId";
export const PARAM_CHUNK_ID = "chunkId";
/** 업로드 화면을 특정 탭으로 여는 진입 파라미터. 현재는 "existing-report" 만 받는다. */
export const PARAM_SOURCE_MODE = "mode";
/** 기존 IXD 탭으로 진입할 때 미리 골라 둘 IXD report. */
export const PARAM_IXD_REPORT_ID = "ixdReportId";

const COMPARE_PATH = "/ixd-dsd-compare";

export const buildComparisonUrl = (
  comparisonId: string,
  chunkId?: string | null,
) =>
  `${COMPARE_PATH}?${new URLSearchParams({
    [PARAM_COMPARISON_ID]: comparisonId,
    ...(chunkId ? { [PARAM_CHUNK_ID]: chunkId } : {}),
  })}`;

export const EXISTING_REPORT_ENTRY_URL = `${COMPARE_PATH}?${PARAM_SOURCE_MODE}=existing-report`;

/** 기존 IXD 탭 진입 URL. reportId 를 주면 그 IXD 가 고른 상태로 열린다. */
export const existingReportEntryUrl = (ixdReportId?: string | null) =>
  ixdReportId
    ? `${COMPARE_PATH}?${new URLSearchParams({
        [PARAM_SOURCE_MODE]: "existing-report",
        [PARAM_IXD_REPORT_ID]: ixdReportId,
      })}`
    : EXISTING_REPORT_ENTRY_URL;
